<template>
  <div class="empty-wrap">
    <img class="icon-empty" :src="emptyIcon" alt=""/>
    <p class="empty-title">{{emptyTitle || $t('message.tableCommon.notFoundInfo')}}</p>
    <!-- <p class="empty-subtitle">{{emptySubtitle}}</p> -->
    <slot></slot>
  </div>
</template>
<script >

export default {
  name: 'EmptyComponent',
  props: {
    /**
     * 空态图标
     */
    emptyIcon: {
      type: String,
      default: require('@/assets/images/table/img-empty-1.png'),
    },
    /**
     * 空态标题
     */
    emptyTitle: {
      type: String,
      default: '',
    },
    /**
     * 空态子标题
     */
    emptySubtitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
  },
  mounted() {
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  .icon-empty {
    display: block;
    width: 150px;
    height: 150px;
  }

  .empty-title {
    font-size: 14px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: $color-text-primary;
    line-height: 32px;
  }

  .empty-subtitle {
    font-size: $font-size-subtitle;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 22px;
  }
}
</style>
